import { Checkbox, Price, TextPassage } from '@petsmart-ui/sparky';
import classNames from 'classnames';

import { decodeEntityString } from '@libs/algolia';

import type { MappedFBTProduct } from '../lib';
import { FBTProductLink } from './FBTProductLink';

export interface FBTProductSelectorProps {
    products: MappedFBTProduct[];
    selectedProductIds: Record<string, boolean>;
    onToggleSelectedProduct: (product: MappedFBTProduct, checked: boolean) => void;
}

export function FBTProductList({
    products,
    selectedProductIds,
    onToggleSelectedProduct,
}: Readonly<FBTProductSelectorProps>) {
    const renderProductName = (product: MappedFBTProduct) => {
        if (product.isMainProduct) {
            return (
                <TextPassage
                    className={classNames(!product.inStock && 'sparky-c-text-link--disabled')}
                    capLinelength={false}
                >
                    <strong>This item:</strong> {decodeEntityString(product.name)}
                </TextPassage>
            );
        }

        return decodeEntityString(product.name);
    };

    return (
        <div className="fbt__product-list" data-testid="fbt-product-list">
            {products.map(product => {
                const isProductChecked = Boolean(selectedProductIds[product.id]);
                const isProductDisabled = !product.inStock;

                return (
                    <div className="fbt__product-list-item" key={product.id}>
                        <Checkbox
                            data-checked={isProductChecked}
                            data-testid={`fbt-checkbox-${product.id}`}
                            value={product.id}
                            checked={isProductChecked}
                            disabled={isProductDisabled}
                            onChange={checked => onToggleSelectedProduct(product, checked)}
                        />
                        {product.url ? (
                            <FBTProductLink className="sparky-c-text-link" href={product.url}>
                                {renderProductName(product)}
                            </FBTProductLink>
                        ) : (
                            renderProductName(product)
                        )}
                        <Price
                            className="sparky-u-display-inline"
                            variant={product.priceStyleVariant}
                            values={[product.displayPrice]}
                        />
                    </div>
                );
            })}
        </div>
    );
}
